export const settings = {
  title: 'Configuración',
  description: 'Ajusta tus preferencias personales.',
};
